<template>
  <q-section v-bind="$attrs" class="ui-checkin1" :bg-i="uiMeta.images.checkinEntry" @click="open()">
    <q-dialog :name="uiMeta?.config?.checkinDialogName" :bg-i="uiMeta.images.checkinDialogBg" pc="pc" :closeable="true">
      <q-section f="14 #CE6C3D 400" class="ws-nowrap" pc="x" pb="88">{{ uiMeta.config.tipText.replace('{progress}',
        progress) }}</q-section>
      <q-section wh="277 230" pc="x" pt="156">
        <q-section wh="100% 50%" class="flex flex-row items-center justify-around" p="relative" pdl="25" pdr="25">
          <q-section :key="`checkin-day-${day}-${progress >= index + 1 ? 'Checked' : 'Check'}`" p="relative"
            v-for="(day, index) in uiMeta.images.checkinDays.slice(0, 3)"
            :bg-i="`checkin-${day}-${progress >= index + 1 ? 'Checked' : 'Check'}`">
            <q-section v-if="progress >= index + 1" :bg-i="uiMeta.images.checkinIconChecked" pt="-4"
              pr="-2"></q-section>
          </q-section>
        </q-section>
        <q-section wh="100% 50%" class="flex flex-row items-center justify-around" p="relative">
          <q-section :key="`checkin-day-${day}-${progress >= index + 4 ? 'Checked' : 'Check'}`" p="relative"
            v-for="(day, index) in uiMeta.images.checkinDays.slice(3)"
            :bg-i="`checkin-${day}-${progress >= index + 4 ? 'Checked' : 'Check'}`">
            <q-section v-if="progress >= index + 4" :bg-i="uiMeta.images.checkinIconChecked" pt="-4"
              pr="-2"></q-section>
          </q-section>
        </q-section>
      </q-section>
      <q-section :key="`checkin-btn-${isSignToday ? 'got' : 'get'}`" wh="88 34" pc="x" pb="33"
        :bg-i="uiMeta.images[`${isSignToday ? 'checkinGot' : 'checkinGet'}`]" @click="signin()"></q-section>
      <q-section wh="30" pl="307" pt="85" @click="closeCheckin"></q-section>
    </q-dialog>
  </q-section>
</template>

<script setup>
import { useCheckin, defaultConfig as uiMeta } from './use-checkin'
const { progress, isSignToday, signin, open, closeCheckin } = useCheckin(uiMeta)
</script>

<style scoped lang="scss"></style>
